import React from 'react'
import './AboutBox.css'

export default function AboutBox() {
    return (
        <>
            <section className="Quota container">
                <figure className="text-center mx-auto">
                    <h3 className="mb-3">About Us</h3>
                    <div className="quota">
                        <p>આવનારા વર્ષોમાં ભાવનગર શૈક્ષણિક ક્ષેત્રે રાષ્ટ્રીય ફલક પર વિસ્તરી રહ્યું છે ત્યારે, આપણા શહેરમાં
                            પૂર્વ વિસ્તારમાં આપણો સમાજ વધુ ને વધુ વિસ્તૃત થતું જાય છે.દુર દુરથી ગ્રામ્યના અંતરિયાળ વિસ્તારમાંથી
                            આપણા સમાજના દીકરા-દીકરીઓ તેમની તેજસ્વી આંખોના સ્વપ્ના સાકાર કરવા અને માતા-પિતાનું ગૌરવ વધારવા, તેમજ
                            રાષ્ટ્રની ઉન્નતી માટે વિકાસની આશા સાથે ઉચ્ચ અભ્યાસ અર્થે ભાવનગર શહેરમાં આવે છે.ત્યારે તેઓને મદદરૂપ
                            થવા આપણે સૌ કટિબદ્ધ અને સંકલ્પબદ્ધ છીએ. ઉચ્ચ અભ્યાસ અર્થે આવતા દીકરાઓને રહેવા-જમવાની વ્યવસ્થા પરવડે
                            તેવા દરે ઉપલભ્ધ થાય, એવા ઉમદા હેતુ સાથે_____
                            "નીરુ પટેલ કુમાર છાત્રાલય"
                            ______નું કાર્ય પૂર્ણ કરી સમાજને લોકાર્પણ કરવાનું આપનું સ્વપ્ન સાકાર થયું છે.

                            "યુવા શક્તિ" સ્વયમમાં આત્મવિશ્વાસુ , સંબંધોમાં સમૃધી અને નિર્ભયતા પ્રાપ્ત કરી સંપૂર્ણપણે શિક્ષિત,
                            દીક્ષિત, વિકસિત અને સ્વયંભુ રક્ષિત થાય એવું આપણે સૌ ઈચ્છીએ છીએ."કેળવણીધામ" ના લક્ષ્યબિંદુઓને અમલમાં
                            મુકવાનું ભગીરથ કામ આપ સૌના સહકારથી સાકાર કરીશું.નવી પેઢીના સોનેરી સ્વપ્ના કેળવણી થકી સાકાર કરવા આપના
                            સહિયારા સુંદર પ્રયાસો થી જ શક્ય છે.આવો અમારા તેજસ્વી, ઓજસ્વી, રાજસ્વી,માનવંતા ભાઈ-બહેનો આપને સહુ
                            નાના-મોટાના ભેદ ભૂલી એક, નેક અને ટેક બની યુવાશક્તિના સર્વાંગી વિકાસ કાજેના પવિત્ર યજ્ઞ કાર્યમાં તન,
                            મન, ધનથી સહભાગી બનીયે. યજ્ઞ કાયવમાાં તન, મન, ધનથી સહભાગી બનીયે.</p>
                    </div>
                </figure>
            </section>
        </>
    )
}
